// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1AcIQ","content":"LoadingAlert_content__3MG0v"};